import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DingoAiMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
  suggestWhatsapp?: boolean;
  whatsappUrl?: string;
}

export interface DingoAiChatResponse {
  reply: string;
  suggestWhatsapp: boolean;
  whatsappUrl?: string;
}

@Injectable({ providedIn: 'root' })
export class DingoAiChatService {
  private readonly baseUrl = environment.backendBaseUrl.replace(/\/+$/, '');

  constructor(private http: HttpClient) {}

  async sendChat(messages: DingoAiMessage[]): Promise<DingoAiChatResponse> {
    const url = `${this.baseUrl}/api/chat`;
    return await firstValueFrom(
      this.http.post<DingoAiChatResponse>(url, { messages })
    );
  }
}

